import { render, staticRenderFns } from "./DsbNotification.vue?vue&type=template&id=5c5aa442&scoped=true"
import script from "./DsbNotification.vue?vue&type=script&lang=ts"
export * from "./DsbNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5aa442",
  null
  
)

export default component.exports